import { Link } from 'react-router-dom'

const variants = {
  primary: 'bg-coral text-white hover:bg-coral-600 shadow-sm shadow-coral-200',
  secondary: 'bg-white text-primary hover:bg-primary-50 border border-primary-200',
  outline: 'bg-transparent text-white border border-white/70 hover:bg-white/10',
}

function Button({ to, href, onClick, type = 'button', variant = 'primary', className = '', children }) {
  const classes = `inline-flex items-center justify-center gap-2 rounded-md px-5 py-2.5 text-sm font-semibold transition-colors duration-150 ${variants[variant]} ${className}`

  if (to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    )
  }

  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    )
  }

  return (
    <button type={type} onClick={onClick} className={classes}>
      {children}
    </button>
  )
}

export default Button
